
import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '@/components/Layout/Layout';
import RoofMaterialsHero from '@/components/RoofMaterials/RoofMaterialsHero';
import MaterialsOverview from '@/components/RoofMaterials/MaterialsOverview';
import InstallationProcess from '@/components/RoofMaterials/InstallationProcess';
import MaterialComparison from '@/components/RoofMaterials/MaterialComparison';
import RoofMaterialsCTA from '@/components/RoofMaterials/RoofMaterialsCTA';

const RoofInstallationsAndMaterialsPage = () => {
  return (
    <Layout>
      <Helmet>
        <title>Roof Installations & Materials | Carolina Trophy Roofs | Eastern NC</title>
        <meta name="description" content="Expert roof installations with premium materials in Eastern NC. Asphalt shingles, metal roofing, TPO, EPDM systems. Professional installation with lifetime warranties." />
        <meta name="keywords" content="roof installation, roofing materials, asphalt shingles, metal roofing, TPO, EPDM, roof replacement, Eastern NC" />
        <link rel="canonical" href="https://carolinatrophyroofs.com/roof-installations-and-materials" />
        
        <meta property="og:title" content="Roof Installations & Materials | Carolina Trophy Roofs" />
        <meta property="og:description" content="Expert roof installations with premium materials in Eastern NC. Asphalt shingles, metal roofing, TPO, EPDM systems." />
        <meta property="og:url" content="https://carolinatrophyroofs.com/roof-installations-and-materials" />
        <meta property="og:type" content="website" />
        
        <meta name="twitter:title" content="Roof Installations & Materials | Carolina Trophy Roofs" />
        <meta name="twitter:description" content="Expert roof installations with premium materials in Eastern NC. Asphalt shingles, metal roofing, TPO, EPDM systems." />
        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Roof Installations & Materials",
            "description": "Professional roof installation services using premium materials including asphalt shingles, metal roofing, TPO, and EPDM systems.",
            "provider": {
              "@type": "RoofingContractor",
              "name": "Carolina Trophy Roofs",
              "telephone": "+1-252-302-2003",
              "url": "https://carolinatrophyroofs.com",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Rocky Mount",
                "addressRegion": "NC",
                "addressCountry": "US"
              }
            },
            "serviceType": "Roof Installation",
            "areaServed": "Eastern North Carolina"
          })}
        </script>
      </Helmet>
      
      <RoofMaterialsHero />
      <MaterialsOverview />
      <InstallationProcess />
      <MaterialComparison />
      <RoofMaterialsCTA />
    </Layout>
  );
};

export default RoofInstallationsAndMaterialsPage;
